export default __webpack_public_path__ + "static/media/evolution.5decd87a.svg";